<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          패턴
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Pattern</a>
          </li>
      </ul>
    </div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card v-if="is_test" class="text-center text-bold">
            <b-row>
              <b-col>
                {{ apply_request }}개의 에이전트에 검사를 요청하였습니다.
                <br>
                전체 검사가 완료되면 정책이 자동으로 활성화됩니다.
                <br>
                정책을 활성화하는 데 문제가 있으면 전자 메일이 전송됩니다.
                <br>
                이메일 알림에 귀 기울여 주세요
              </b-col>
            </b-row>
            <hr>
            <b-row v-if="apply_alive != apply_request" class="text-center">
              <b-col>
                <h6 class="text-danger">단, {{ apply_alive }} 개의 에이전트만 온라인 상태로 그 외 에이전트는 오프라인으로 패턴 테스트가 불가합니다 </h6>
                <h6 class="text-danger">패턴 테스트를 적용하려면 온라인 상태로 전환 후 다시 테스트를 진행헤주세요  </h6>
                <h6 class="text-danger">패턴 테스트를 적용하지 않은 에이전트이 경우, 격리 모드 사용시 바로 격리됩니다 향후 의도치 않은 서비스 장애가 발생할 수 있습니다 </h6>
                <h6 class="text-danger">패턴이 활성화 되지 않을 경우 Q&A 혹은 파트너에게 문의해주세요 </h6>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-button block size="ml" class="text-white" variant="secondary" @click="list"> List </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-else>
            <b-row>
              <b-col>
                <strong>패턴 상세</strong>
                <span class="float-right">{{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="is_use_true">사용여부</label><br/>
                <c-switch v-model="model.is_alive"  :disabled="lock" color="success" label variant="pill"/><br>
              </b-col>
              <b-col>
                <label for="ph_type">카테고리</label>
                <b-form-select v-model="model.category" :options="codes.code_category" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_ext">종류</label>
                <b-form-select v-model="model.ext" :options="codes.code_ext" :disabled="lock"></b-form-select>
              </b-col>
              <b-col>
                <label for="ph_type">타입</label>
                <b-form-select v-model="model.type" :options="codes.code_type" :disabled="lock"></b-form-select>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_code">코드</label>
                <b-form-input md="5" type="text" id="ph_code" v-model="model.code" :disabled="lock"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <label for="ph_content">설명</label>
                <b-form-textarea :rows="3" v-model="model.description" id="ph_content" :disabled="lock"></b-form-textarea>
              </b-col>
            </b-row>
            <hr>
            * 패턴의 영향도를 확인하기 위해 현재 패턴으로 전체 스캔을 진행합니다(권장).
            <br>
            패턴 미리 검사를 진행하지 않을 수 있지만 권장하지 않습니다
            <br>
            패턴의 적용 여부, 탐지 결과는 메일로 안내 드리겠습니다
            <hr>

            <b-button class="btn-add" v-if="!lock" size="sm" variant="success" @click="modal_save = true"> 저장 </b-button>
            <b-button v-else="lock" size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
            <b-button v-if="!lock" size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
            <b-button v-else="lock" size="sm" variant="danger" @click="confirm = true"> 삭제 </b-button>
            <b-button v-if="lock" size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
          </b-card>
        </b-col>
      </b-row>
    <b-modal title="삭제"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
     해당 패턴을 삭제하시겠습니까?
    </b-modal>
    <b-modal title="Test"  class="modal-danger" v-model="modal_save" hide-footer ok-variant="danger">
      <h6> <span class="text-primary">Test</span> : 패턴 테스트 이후에 적용합니다</h6>

      <h6> <span class="text-danger">Save</span> : 패턴 테스트 없이 바로 적용합니다(강제)</h6>

      <hr>
      <b-button block size="sm" variant="primary" @click="test"> Test </b-button>
      <b-button block size="sm" variant="danger" @click="save" class="btn-addition"> Save </b-button>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
